import React, { Component } from "react";
import ReactDOM from "react-dom";
import Increment from "../helper_components/Increment";
import CurrencyInput from "react-currency-input";
import { Button, Tab } from "react-bootstrap";
import moment from "moment";
class SumiagroCostAddComponent extends Component {
  constructor(props) {
    super(props);

    this.showCostForm = this.showCostForm.bind(this);
    this.deleteCostForm = this.deleteCostForm.bind(this);
    this.setFieldForCostPhotos = this.setFieldForCostPhotos.bind(this);
    this.setFieldForFormType = this.setFieldForFormType.bind(this);
    this.state = {
      icon: "fa-angle-right",
      display: "none",
      costBrandShow: false,
      costTypeList: [],
      paymentTypeList: [],
      costMoneyTypeList: [],
      kdvOrani: [],
      kdvOraniAktif: false,
      formType: "applicationSumiagro",
      isfutureDateCostAllowed: true,
      formFieldsAndRequirements: {},
    };
  }

  componentDidMount() {
    let { costNumber, parent } = this.props;
    parent.state.costFormComponents[costNumber - 1].refs = this.refs;
    const employeeInfo = JSON.parse(
      window.localStorage.getItem("employeeInfo")
    );
    if (employeeInfo !== null) {
      this.setFieldForFormType("applicationSumiagro")
      this.setState({
        costTypeList: employeeInfo.costType,
        paymentTypeList: employeeInfo.paymentType,
        costMoneyTypeList: employeeInfo.costMoneyType,
        kdvOrani: employeeInfo.kdvOrani,
        kdvOraniAktif: employeeInfo.kdvOraniAktif,
        formFieldsAndRequirements: employeeInfo.formFieldsAndRequirements,
      });
    }
  }

  showCostForm() {
    if (this.state.display === "none") {
      this.setState({
        display: "block",
        icon: "fa-angle-down",
      });
    } else {
      this.setState({
        display: "none",
        icon: "fa-angle-right",
      });
    }
  }
  deleteCostForm() {
    var { parent, costNumber } = this.props;
    if (costNumber - 1 != 0) {
      parent.state.costFormComponents[costNumber - 1] = null;
      ReactDOM.findDOMNode(this).remove();
      parent.setState({
        costFormComponents: parent.state.costFormComponents,
      });
    }
  }
  setFieldForCostPhotos() {
    this.props.parent.state.costFormComponents[
      this.props.costNumber - 1
    ].costPhotos = ReactDOM.findDOMNode(this).querySelectorAll(".costPhoto");   
  }
  setFieldForFormType(formType) {
      this.setState({formType:formType})
      const costNumber =  this.props.costNumber - 1
      this.props.parent.state.costFormComponents[costNumber].formType = formType
      const costDate = this.props.parent.state.costFormComponents[costNumber].refs.costDate
    
      let isfutureDateCostAllowed = formType === "applicationSumiagro";
      this.setState({isfutureDateCostAllowed})
      if(!isfutureDateCostAllowed && moment(costDate.value) > moment()){
        costDate.value=""
      }
      
  }
  handleOnChange = (event) => {
    if (event.target.value != "Genel Gider") {
      this.setState({ costBrandShow: true });
    } else {
      this.setState({ costBrandShow: false });
    }
  };
  render() {
    let {
      costNumber,
      costTypes,
      maxCostTime,
      parent,
      kdvOrani,
      kdvOraniAktif,
      paymentType,
      costCategory,
      costLocation,
      costBrand,
      t
    } = this.props;
    var getAllMoney = new window.Money().getAllMoney();
    var getAllMoneyI18nCodes= new window.Money().getAllMoneyI18nCodes() 
    let { display, formType, isfutureDateCostAllowed, formFieldsAndRequirements } = this.state;
    return (
      <div className="card panel-CostAdd">
        <div className="header">
          <div className="col-md-11 col-xs-10">
            <h4 className="title">
              <button
                onClick={this.showCostForm}
                className="btn btn-wd actionBtn2 actionBtn"
                id={"costMenuButton-" + costNumber}
              >
                <i className={"fa " + this.state.icon}></i>
              </button>{" "}
              &nbsp; {t("cost")}{" "}
              <span ref="cost_number" id={"costNumber-" + costNumber}>
                {costNumber}
              </span>
            </h4>
          </div>
          {costNumber !== 1 ? (
            <div className="col-md-1 col-xs-2">
              <btn
                className="btn btn-xs btn-danger"
                onClick={this.deleteCostForm}
              >
                <i className="fa fa-trash"></i>
              </btn>
            </div>
          ) : null}
        </div>
        <div className="content costAddComponent" style={{ display: display }}>
          <div className="text-center">
          <h1></h1>
         </div>
          <div className="content table-responsive table-full-width">
          <div
              className="col-md-6 costAddColumn"
              id={"addCostCostType-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("costFormType")}</label>
              <select
                className="form-control border-input"
                defaultValue="applicationSumiagro"
                onChange={(e) => this.setFieldForFormType(e.target.value)}
              >
                <option value="applicationSumiagro">Application</option>
                <option value="settlementSumiagro">Settlement</option>
              </select>
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addCostCostDate-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("costDate")}</label>
              <input
                type="date"
                id={"addCostCostDateInput-" + costNumber}
                max={formType === "applicationSumiagro" ? "" : moment().format("Y-MM-DD")}
                onBlur={(e) => {
                  this.props.onChangeDate(
                    e,
                    parent.props.maxCostTime,
                    parent.state.costFormComponents[0].refs.costDate.value || 0,
                    e.target.value, 
                    isfutureDateCostAllowed                   
                  );
                }}
                defaultValue=""
                ref="costDate"
                className="form-control border-input"
                placeholder={t("costDate")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addCostInvoiceNo-" + costNumber}
            >
            {
                formType === "settlementSumiagro" ?  
                 <span className="star">*</span>
              : null
            }
              <label>{t("invoiceReceiptNo")}</label>
              <input
                type="text"
                defaultValue=""
                id={"addCostInvoiceNoInput-" + costNumber}
                ref="invoiceNo"
                className="form-control border-input"
                placeholder={t("invoiceReceiptNo")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addCostCostType-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("costType")}</label>
              <select
                className="form-control border-input"
                defaultValue=""
                id={"addCostCostTypeInput-" + costNumber}
                ref="costType"
              >
                <option value="-1">{t("selectAnCostType")}</option>
                {this.state.costTypeList.map((data, key) => {
                  return (
                    <option value={data.type} key={key}>
                      {data.type}
                    </option>
                  );
                })}
              </select> 
            </div>
            {
                formType === "settlementSumiagro" ? 
           ( <>
            <div
              className="col-md-6 costAddColumn"
              id={"addCostCostAmount-" + costNumber}
            >
              <label>{t("preApprovedBudget")}</label>
              <CurrencyInput
                value={
                  this.refs.preApprovedBudget ? this.refs.preApprovedBudget.state.value : 0
                }
                id={"addCostCostAmountInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("preApprovedBudget")}
                ref="preApprovedBudget"
              />
            </div>
            
            <div
              className="col-md-6 costAddColumn"
              id={"addactualExpenditureCostCostAmount-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("actualExpenditure")}</label>
              <CurrencyInput
                value={
                  this.refs.costAmount ? this.refs.costAmount.state.value : 0
                }
                id={"addaActualExpenditureCostAmountInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("actualExpenditure")}
                ref="costAmount"
              />
            </div>
            </>) :
            <div
              className="col-md-6 costAddColumn"
              id={"addCostCostAmount-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("costAmount")}</label>
              <CurrencyInput
                value={
                  this.refs.costAmount ? this.refs.costAmount.state.value : 0
                }
                id={"addCostCostAmountInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("costAmount")}
                ref="costAmount"
              />
            </div>
            
            }
            { formType === "applicationSumiagro" ?
            <div
              className="col-md-6 costAddColumn"
              id={"addCostMoneyType-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("currencyUnit")}</label>
              <select
                className="form-control border-input"
                defaultValue="TL"
                id={"addCostMoneyTypeInput-" + costNumber}
                ref="moneyType"
              >
                <option value="-1">{t("selectCurrencyUnit")}</option>
                {
                     this.state.costMoneyTypeList.map((data, key) => {
                         return <option value={data.type}>({getAllMoney[data.type]}) {t(getAllMoneyI18nCodes[data.type])}</option>
                     })
                 }                
              </select>
            </div> : null
            }
            <div
              className="col-md-6 costAddColumn"
              id={"addCompanyName-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("company")}</label>
              <input
                type="text"
                defaultValue=""
                ref="companyName"
                id={"companyNameInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("company")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addPlaceName-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("place")}</label>
              <input
                type="text"
                defaultValue=""
                ref="placeName"
                id={"placeNameInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("place")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addGuestName-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("guests")}</label>
              <input
                type="text"
                defaultValue=""
                ref="guestName"
                id={"guestNameInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("guests")}
              />
            </div>
            
            <div
              className="col-md-6 costAddColumn"
              id={"addGuestNumber-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("guestNumber")}</label>
              <input
                type="number"
                min="0"
                defaultValue=""
                ref="guestNumber"
                id={"guestNumberInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("guestNumber")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addStaffName-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("staff")}</label>
              <input
                type="text"
                defaultValue=""
                ref="staffName"
                id={"staffNameInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("staff")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addStaffNumber-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("staffNumber")}</label>
              <input
                type="number"
                min="0"
                defaultValue=""
                ref="staffNumber"
                id={"staffNumberInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("staffNumber")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addOtherParticipantsName-" + costNumber}
            >
              <label>{t("otherParticipants")}</label>
              <input
                type="text"
                defaultValue=""
                ref="otherParticipant"
                id={"otherParticipantInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("otherParticipants")}
              />
            </div>
            <div
              className="col-md-6 costAddColumn"
              id={"addOtherParticipantNumber-" + costNumber}
            >
              <label>{t("otherParticipantNumber")}</label>
              <input
                type="number"
                min="0"
                defaultValue=""
                ref="otherParticipantNumber"
                id={"otherParticipantNumberInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("otherParticipantNumber")}
              />
            </div>
            {costLocation && costLocation.length > 0 ? (
              <div
                className="col-md-6 costAddColumn"
                id={"addCostCostLocationType-" + costNumber}
              >
                <span className="star">*</span>
                <label>{t("costFormType")}</label>
                <select
                  className="form-control border-input"
                  defaultValue=""
                  id={"addCostCostLocationTypeInput-" + costNumber}
                  ref="costLocation"
                >
                  <option value="-1">{t("chooseCostFormType")}</option>
                  {costLocation.map((data, key) => {
                    return (
                      <option value={data.type} key={key}>
                        {data.type}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}
            {costCategory && costCategory.length > 0 ? (
              <div
                className="col-md-6 costAddColumn"
                id={"addCostCostCategoryType-" + costNumber}
              >
                <span className="star">*</span>
                <label>{t("costCategory")}</label>
                <select
                  className="form-control border-input"
                  defaultValue=""
                  id={"addCostCostCategoryTypeInput-" + costNumber}
                  ref="costCategory"
                  onChange={this.handleOnChange}
                >
                  <option value="-1">{t("selectCostCategory")}</option>
                  {costCategory.map((data, key) => {
                    return (
                      <option value={data.type} key={key}>
                        {data.type}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}
            {costBrand && costBrand.length > 0 && this.state.costBrandShow ? (
              <div
                className="col-md-6 costAddColumn"
                id={"addCostCostBrandType-" + costNumber}
              >
                <span className="star">*</span>
                <label>{t("costBrand")}</label>
                <select
                  className="form-control border-input"
                  id={"addCostCostBrandTypeInput-" + costNumber}
                  defaultValue=""
                  ref="costBrand"
                >
                  <option value="-1">{t("selectCostBrand")}</option>
                  {costBrand.map((data, key) => {
                    return (
                      <option value={data.type} key={key}>
                        {data.type}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}
            { formType === "settlementSumiagro" ?
            <div
              className="col-md-6 costAddColumn"
              id={"addCostMoneyType-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("currencyUnit")}</label>
              <select
                className="form-control border-input"
                defaultValue="TL"
                id={"addCostMoneyTypeInput-" + costNumber}
                ref="moneyType"
              >
                 <option value="-1">{t('selectCurrencyUnit')}</option>
                 {
                     this.state.costMoneyTypeList.map((data, key) => {
                         return <option value={data.type}>({getAllMoney[data.type]}) {t(getAllMoneyI18nCodes[data.type])}</option>
                     })
                 }         
              </select>
            </div> : null
            }
            <div
              className="col-md-6 costAddColumn"
              id={"addCostPaymentType-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("paymentType")}</label>
              <select
                className="form-control border-input"
                defaultValue=""
                id={"addCostPaymentTypeInput-" + costNumber}
                ref="paymentType"
              >
                <option value="-1">{t("selectPaymentType")}</option>
                {this.state.paymentTypeList.map((data, key) => {
                  return (
                    <option value={data.type} key={key}>
                      {data.type}
                    </option>
                  );
                })}
              </select>
            </div>
            {kdvOraniAktif === "true" ? (
              <div
                className="col-md-6 costAddColumn"
                id={"addCostKDVRatio-" + costNumber}
              >
                <span className="star">*</span>
                <label>{t("vatRate")}</label>
                <select
                  className="form-control border-input"
                  defaultValue=""
                  id={"addCostKDVRatioInput-" + costNumber}
                  ref="kdvOrani"
                >
                  <option value="-1">{t("selectVatRate")}</option>
                  {(this.state.kdvOrani || []).map((data, key) => {
                    return (
                      <option value={data.type} key={key}>
                        {data.type}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}
            <div
              className="col-md-12 costAddColumn"
              id={"addCostSupplierName-" + costNumber}
            >
              <label>{t("supplierName")}</label>
              <input
                type="text"
                defaultValue=""
                ref="supplierName"
                id={"addCostSupplierNameInput-" + costNumber}
                className="form-control border-input"
                placeholder={t("supplierName")}
              />
            </div>
            <div
              className="col-md-12 costAddColumn"
              id={"addCostCostDescription-" + costNumber}
            >
              <span className="star">*</span>
              <label>{t("description")}</label>
              <textarea
                ref="costDescription"
                defaultValue=""
                id={"addCostCostDescriptionInput-" + costNumber}
                placeholder={t("enterProvinceAndReasonForExpense")}
                className="form-control border-input"
              ></textarea>
            </div>
            <Increment t={t} costNumber={costNumber} setCostPhoto={this.setFieldForCostPhotos} required={formFieldsAndRequirements.costPhoto}/>
          </div>
        </div>
      </div>
    );
  }
}

export default SumiagroCostAddComponent;
